/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, pxToEm, disable } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles } from 'utils/themeV2';
import { url } from 'utils/urls';


/* ++++++++++ --------------- EXPORT : REQUEST COMMENT WIDGET : STYLES --------------- ++++++++++ */
export default theme => ({
    requestcommentwidget: {
        backgroundImage: `url(${url.image}/illustration-bubble-background.svg)`,
        background: 'right top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        padding: `${pxToEm(70)} 5% 6.25em`,
        marginBottom: pxToEm(50),
    
        // '& .name-page-details':{
        //     justifyContent: 'center',
        //     display: 'flex',
        //     flexWrap: 'wrap',
        //     '& img':{
        //         maxWidth: pxToEm(675),
        //         width: '55%'
        //     }
        // },


        // flex to align copy and graphic
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',


        // copy
        '& .requeststatus':{
            maxWidth: pxToEm(432),
            margin: replacePXinStringWithEM('85px 0px 85px 0'),

            // animation
            opacity: '0',
            animationName: 'fadeInLeft',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        // graphic
        '& .graphic': {
            flex: '1',
            maxWidth: pxToEm(675),
            minWidth: pxToEm(300),
            '& img': {
                width: '100%',
                height: 'auto'
            },

            // animation
            opacity: '0',
            animationName: 'fadeInRight',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '&.disabled-true': {
            extend: disable
        },
        ...buttonStyles
    }
    // [mediaQuery.thinnest]: {
    //     requestcommentwidget: {
    //         '& img, .requeststatus':{
    //             margin: `0 0 ${pxToEm(50)}`,
    //             width: '100% !important',
    //             maxWidth: '100%'
    //         }
    //     }
    // }
});